import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img src="https://customer-assets.emergentagent.com/job_revotech-preview/artifacts/irwgjbpt_10x%20black%20background%20and%20white%20text.png" alt="RevoTech" className="h-10" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/80 hover:text-white transition-colors duration-200"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white/80 hover:text-white transition-colors duration-200"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="text-white/80 hover:text-white transition-colors duration-200"
            >
              Partners
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#5B42FF] hover:bg-[#4a35db] text-white transition-all duration-300 hover:scale-105"
            >
              Contact Us
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-4 animate-in fade-in slide-in-from-top-2 duration-300">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-left"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-left"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-left"
            >
              Partners
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#5B42FF] hover:bg-[#4a35db] text-white w-full"
            >
              Contact Us
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};